// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1O23q","productName":"Table_productName__1ZLYz"};